export default __webpack_public_path__ + "static/media/1047.7bb6dee5.png";